'use client';

import { type PropsWithChildren } from 'react';
import type { SavvySession } from '@auth';
import { SessionProvider } from '@lib/auth/client';

// Apollo
import { ApolloWrapper } from '@lib/apollo';

// Contexts
import { NotificationProvider } from '@contexts/use-notification';
import { AnalyticsProvider } from '@contexts/use-analytics';
import { ExperimentsProvider } from '@contexts/use-experiments';
import { SessionHandler } from '@components/auth/session-handler';

interface HostProvidersProps extends PropsWithChildren {
  session: SavvySession | null;
}

/**
 * Client-side providers wrapper for Host/PM App Router pages.
 * Provides session, Apollo client, notifications, and analytics.
 */
export function HostProviders({ session, children }: HostProvidersProps) {
  return (
    <SessionProvider session={session}>
      <ApolloWrapper>
        <NotificationProvider>
          <AnalyticsProvider>
            <ExperimentsProvider>
              <SessionHandler />
              {children}
            </ExperimentsProvider>
          </AnalyticsProvider>
        </NotificationProvider>
      </ApolloWrapper>
    </SessionProvider>
  );
}
